<template>
    <Modal>
        <Loading :label="label" />
    </Modal>
</template>
<script lang="ts">
    import { defineComponent } from 'vue';
    import Modal from '@ui/components/Modal/Modal.vue';
    import Loading from '@ui/components/Loading/Loading.vue';

    export default defineComponent({
        name: 'ModalSpinner',
        props: { label: String },
        components: { Modal, Loading },
    });
</script>
